import React from "react";

import InternalTag from "Components/InternalTag";
import PageMeta from "Components/PageMeta";
import ServiceIcon from "Components/ServiceIcon";
import { BackLink } from "ds/Button";
import { selectFeatureUsageBasedBillingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import TimeframeControl from "src/organization/pages/project/environment/metrics/components/timeframeControl/TimeframeControl";
import usePinnedTabsSync from "src/organization/pages/project/environment/metrics/hooks/usePinnedTabsSync";
import { useAppSelector } from "Store/hooks";

import Sellable from "../sellable/Sellable";
import { FlexWrapper } from "../services/style";
import { ApplicationType } from "../type";

import * as S from "./Page.styles";
import { ProfilerInjectProps } from "./ProfilingWrapper";

import type { DeploymentService } from "@packages/client";

type WidgetAppProps = {
  onviewApp: (app?: ApplicationType) => void;
  appService?: DeploymentService;
};

const WidgetApp = (props: WidgetAppProps) => {
  const {
    timeframe,
    setTimeframe,
    poll,
    lastUpdated,
    appService,
    onviewApp,
    deploymentProps,
    app
  } = props as ProfilerInjectProps<WidgetAppProps>;

  const usageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);

  const { onSyncChange, isSynced, canJoinSync } = usePinnedTabsSync({
    timeframe,
    setTimeframe
  });

  const handleSyncChange = (isSynced: boolean) => {
    onSyncChange(isSynced, timeframe);
  };

  return (
    <>
      <PageMeta title="Profiling" />
      <Sellable />
      <S.Header>
        <div>
          <BackLink
            onClick={() => onviewApp()}
            type=""
            from="profiling"
            to={window.location.pathname}
          />

          <FlexWrapper gap={16}>
            <ServiceIcon service={appService} alt={`${appService}-icon`} />
            <S.Heading tag="h2">
              {app.name} &nbsp; {!usageBilling && <InternalTag />}
            </S.Heading>
          </FlexWrapper>
        </div>

        <TimeframeControl
          timeframe={{
            timeframe,
            onChange: setTimeframe
          }}
          deployment={deploymentProps}
          pollInterval={poll}
          lastUpdated={lastUpdated}
          tabSync={{
            onSyncChange: handleSyncChange,
            isSynced,
            canJoinSync
          }}
        />
      </S.Header>
    </>
  );
};

export default WidgetApp;
